// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__zvnsC","sub-heading":"style_sub-heading__qfoN7","small-text":"style_small-text__8EgtQ"};